<template>
  <b-sidebar
    v-if="isShowSidebar"
    v-model="isShowSidebar"
    id="local-sidebar-right-email-tracking"
    right
    backdrop
    shadow
    :width="['sm','md'].includes($mq) ? '109em':'90%'"
    backdrop-variant="dark"
    no-close-on-backdrop
    @change="closeSidebar"
  >
    <template #title>
      <div>
        <strong id="sidebar-right___title__">Письмо поставщику #{{ editedItem.id }}</strong>
      </div>
    </template>

    <div class="d-block letter-container">
      <template v-if="loading">
        <tsoft-wrapper :loading="loading"></tsoft-wrapper>
      </template>
      <template v-else>
        <div class="sidebar-cards" v-if="editedItem.company_employee">
          <b-card bg-variant="light" header="Решение по запросу">
            <b-card-text>
              <div class="mb-2">
                <template v-if="editedItem.selected">
                  <span class="text-success font-bold">Выбрали к сотрудничеству</span>
                </template>
                <template v-else-if="editedItem.desire === true">
                  <span class="text-success font-bold">Можно сотрудничать</span>
                </template>
                <template v-else-if="editedItem.desire === false">
                  <span class="text-danger font-bold">Не будем сотрудничать</span>
                </template>
                <template v-else>
                  <span class="text-muted font-bold">Не определились</span>
                </template>
              </div>
              <div class="desire-small-text">
                <span v-if="editedItem.desire_comment" v-html="formattedBody(editedItem.desire_comment)"></span>
                <span v-else>Комментарий пока не оставлен</span>
              </div>
            </b-card-text>
          </b-card>

          <b-card bg-variant="light" class="mt-4" header="Контакт поставщика">
            <b-card-text>
              <div class="desire-small-text">
                <b class="name">{{ editedItem.company_employee.lead_fio }}</b>
                <i class="fas fa-copy copy-icon" @click="copyToClipboardInTable(editedItem.company_employee.lead_fio)"></i><br>
                <span v-if="editedItem.company_employee.lead_phone">
                  <a :href="`tel:+${editedItem.company_employee.lead_phone}`">+{{ editedItem.company_employee.lead_phone }}</a>
                  <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(editedItem.company_employee.lead_phone)"></i><br>
                </span>
                <span v-if="editedItem.company_employee.lead_company_phone">
                  {{ editedItem.company_employee.lead_company_phone }}
                  <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(editedItem.company_employee.lead_company_phone)"></i><br>
                </span>
                <span v-if="editedItem.company_employee.lead_email">
                  <a :href="`mailto:${editedItem.company_employee.lead_email}`">{{ editedItem.company_employee.lead_email }}</a>
                  <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(editedItem.company_employee.lead_email)"></i>
                </span>
              </div>
            </b-card-text>
          </b-card>
        </div>

        <div class="sent-letter" v-if="editedItem.order_supplier_request">
          <p class="letter-meta"><b>Отправлено:</b> {{ editedItem.sent_at || '—' }}</p>
          <p class="letter-meta"><b>Тема:</b> {{ editedItem.order_supplier_request.subject }}</p>
          <div class="letter-body" v-html="editedItem.order_supplier_request.body"></div>
        </div>
      </template>
    </div>
  </b-sidebar>
</template>

<script>
  import { API_EMAIL_TRACKING } from "@/constants";
  import { dataHelpers, tablePrepareData } from "@/mixins";

  const initialEditedItem = () => ({
    id: '',
    sent_at: '',
    order_supplier_request: {},
    company_employee: {},
    desire: null,
    desire_comment: '',
    selected: false
  });

export default {
  mixins: [dataHelpers, tablePrepareData],
  props: {
    id: { type: [Number, String], required: true },
  },
  data() {
    return {
      isShowSidebar: false,
      editedItem: {},
      loading: false
    };
  },
  mounted() {
    this.showItemById(this.id);
  },
  methods: {
    closeShowSidePanelCallback() {
      this.editedItem = initialEditedItem();
      this.isShowSidebar = false;
      this.$emit('onClose');
    },
    closeSidebar() {
      this.closeShowSidePanelCallback();
    },
    showItemById(id) {
      this.isShowSidebar = true;
      this.loading = true;
      this.editedItem = initialEditedItem();

      api.call('get', `${API_EMAIL_TRACKING}/${id}`)
        .then(response => {
          this.editedItem = { ...response.data };
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error('Error fetching item data by ID:', error);
        });
    },
    formattedBody(text) {
      const paragraphs = text.split(/\r?\n/).filter(line => line.trim() !== '');
      return paragraphs.map(line => `<p class="mb-2">${line}</p>`).join('');
    },
  }
};
</script>

<style scoped>
.letter-container {
  padding: 1em;
  height: 100%;
  overflow-y: auto;
}

.sidebar-cards {
  max-width: 300px;
  float: left;
  margin-right: 1em;
}

.sent-letter {
  overflow: hidden;
  padding: 1em;
  background-color: #f8f9fa;
  border-radius: 8px;
  min-height: 200px;
}

.letter-meta {
  margin-bottom: 0.5em;
  font-size: 0.9em;
}

.letter-body {
  margin-top: 1em;
  font-size: 0.9em;
  text-align: left;
}
</style>
